import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="ADVISORY & TRANSACTION SERVICES"
            description={
              <span>
                <p>
                  With our dedicated specialists in our Transaction Services business, we can bring you, our client, a combination of financial, commercial and operational insight to every deal. We deliver unparalleled knowledge as we navigate the deal process with you.
Whether you are making an acquisition, divestiture, or strategic alliance, in each case we have the same objective – to make sure you get the maximum return on your deal.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY MANAGEMENT"
            description={
              <span>
                <p>
                  We strategically manage your assets to increase their value
At Kinos we understand that we have three clients in asset management:
 the property owner, the tenants and the customers.Our management teams use innovative and effective tools in a highly collaborative and national and international environment,
  where knowledge are shared.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="RELATIONSHIPS"
            description={
              <span>
                <p>
                  Kinos are dedicated to finding tailor-made solutions to meet our members’ needs our comprehensive network of expertise, knowledge and relationships. We build crucial and solid relationships. Building Trust.
Building relationships is crucial to your success of business operations.
Kinos maintain strong and constant communications with investors, owners and big network of professionals
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY SALES"
            description={
              <span>
                <p>
                  Property Sales offers customized investment dispositions, acquisition and recapitalization services, together with industry leading market intelligence, to provide our clients with unmatched exposure to buyers.  Our Property Sales professionals are connected to their peers in Spain and gateway cities around the world, providing investment and advisory services to  investors, companies, family office and sophisticated institutional capital.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
      </GridItem>
        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment strategies</h3>
            <span>
              <p>
                <h5>Management of JV or Development Process</h5>
                <h5>Financial Operating Modelling</h5>
                <h5>Budgeting and control</h5>
                <h5>Legal Structuring and Specifications</h5>
                <h5>Tech-Enabled Interaction</h5>
                <h5>Financial Reporting</h5>
                <h5>Operation Reporting</h5>
                <h5>Marketing Strategy</h5>
                <h5>Sales Strategy</h5>
                <h5>Life Cycle Cost Analysis</h5>
                <h5>Asset Positioning</h5>
                <h5>Exit Strategy</h5>
              </p>

            </span>
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment channels</h3>
            <span>

                <h6>Direct Investments</h6>
                <h5>In real estate assets </h5>
                <h5>In projects</h5> 
                <h6>Through Intermediaries</h6>
                <h5>InvestmentManagers </h5>
                <h5>Private equity funds </h5>
                <h5>Infrastructure funds</h5> 
                <h5>Socimis</h5> 
                <h5>Reits</h5> 
                <h6>Other pooled investment vehicles...</h6>

            </span>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
